import { Routes } from '@angular/router';
import { CustomerComponent } from './pages/customer/customer.component';
import { AddOrEditCustomerComponent } from './pages/customer/components/add-or-edit-customer/add-or-edit-customer.component';
import { ApplicationsComponent } from './pages/applications/applications.component';
import { ProfilesComponent } from './pages/profiles/profiles.component';
import { UserComponent } from './pages/user/user.component';
import { AssignResourceComponent } from './pages/applications/components/assign-resource/assign-resource.component';
import { RoleConfigComponent } from './pages/profiles/components/role-config/role-config.component';
import { UserConfigComponent } from './pages/user/components/user-config/user-config.component';

export const userMgmtRoutes: Routes = [
  {
    path: 'customer',
    children: [
      {
        path: '',
        component: CustomerComponent
      },
      {
        path: 'addCustomer',
        component: AddOrEditCustomerComponent
      }
    ]
  },
  {
    path: 'applications',
    children: [
      {
        path: '',
        component: ApplicationsComponent
      },
      {
        path : 'assignResource',
        component : AssignResourceComponent
      }
    ]
  },
  {
    path : 'roles',
     children: [
      {
        path: '',
        component: ProfilesComponent
      },
      {
        path: 'config',
        component: RoleConfigComponent
      }
    ]
  },

   {
    path : 'users',
     children: [
      {
        path: '',
        component: UserComponent
      },
      {
        path: 'config',
        component: UserConfigComponent
      },
    ]
  }
];
